module.exports = __webpack_public_path__ + "static/media/what-is-typeform.efb626c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/what-is-typeform.jpg
// module id = 849
// module chunks = 0